@if (pending()) {
    <app-placeholder-card />
} @else {
    @if (activePaymentMethod()) {
        <app-portal-collapsible
            title="Bezahlmethode"
            icon="credit_card"
        >
            <app-payment-method-widget-details
                [paymentMethod]="activePaymentMethod()"
                (edit)="editCurrentPaymentMethod()"
                (add)="addQueuedPaymentMethod()"
            />

            @for (queuedMethod of queuedPaymentMethods(); track queuedMethod.id; let isFirst = $first) {
                <hr
                    class="m-24:v"
                    [class.bc:grey-1]="isFirst"
                />
                @if (isFirst) {
                    <h4 class="changes-heading c:blue-700 m-24:b">
                        <i ctrlIcon="schedule"></i><span>Geplante Änderungen</span>
                    </h4>
                }

                <app-payment-method-widget-details
                    [paymentMethod]="queuedMethod"
                    [queued]="true"
                    (edit)="editQueuedPaymentMethod(queuedMethod)"
                    (delete)="deletePaymentMethod(queuedMethod)"
                />
            }
        </app-portal-collapsible>
    } @else {
        <app-portal-collapsible
            title="Bezahlmethode nicht verfügbar"
            icon="credit_card"
        >
            <i
                collapsibleHeading
                class="c:red"
                ctrlIcon="warning"
                aria-label="Nicht verfügbar"
            ></i>
            <p>Bei neuen Verträgen kann es eine Weile dauern, bis die Bezahlmethode verfügbar wird.</p>
            <p>
                Falls dir die Bezahlmethode innerhalb der nächsten Tage weiterhin nicht angezeigt wird, wende dich bitte
                an unseren Kundendienst.
            </p>
        </app-portal-collapsible>
    }
}
